import { render, staticRenderFns } from "./PinCompletionTally.vue?vue&type=template&id=20757e32&"
import script from "./PinCompletionTally.vue?vue&type=script&lang=js&"
export * from "./PinCompletionTally.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports